import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import NavTabs from '@/views/NavTabs'
import Home from '@/views/Home'
import ShipSchedule from '@/views/ShipSchedule'
import OgisticsTrack from '@/views/OgisticsTrack'
import AboutUs from '@/views/AboutUs'
import LogisticsManage from '@/views/LogisticsManage'
import NewMenuTabs from '@/views/NewMenuTabs'
import Login from '@/views/Login'
import ForgetPassword from '@/views/ForgetPassword'
import Register from '@/views/Register'
import Account from '../views/steward/account.vue'
import Order from '@/views/steward/Order'
import OrderTwo from '@/views/steward/orderTwo'
import Bill from '@/views/steward/bill'
import Invite from '@/views/Invite';
import ShippingPlan from '@/views/ShippingPlan'
import plan from '@/views/table/plan'
import planMap from '../views/table/planMap.vue'
import Monitoring from "../views/table/Monitoring.vue"

Vue.use(Router)
const routerPush = Router.prototype.push;//解决导航报错
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {//tab导航栏
      path: '/',
      name: 'NavTabs',
      component: NavTabs,
      redirect: "/home",
      children: [
        {//首页
          path: '/home',
          name: 'Home',
          component: Home,
          meta: {
            title: '首页'
          }
        }, {//船期查询
          path: '/shipSchedule',
          name: 'ShipSchedule',
          component: ShipSchedule,
          meta: {
            title: '船期查询'
          }
        }, {//船舶计划
          path: '/ShippingPlan',
          name: 'ShippingPlan',
          component: ShippingPlan,
          meta: {
            requiresAuth: true,
            title: '船舶计划'
          }
        },
        {//物流跟踪
          path: '/ogisticsTrack',
          name: 'OgisticsTrack',
          component: OgisticsTrack,
          meta: {
            requiresAuth: true,
            title: '物流跟踪'
          }
        }, {//关于我们
          path: '/aboutUs',
          name: 'AboutUs',
          component: AboutUs,
          meta: {
            title: '关于我们'
          }
        }, {//物流管家
          path: '/logisticsManage',
          name: 'LogisticsManage',
          component: LogisticsManage,
          meta: {
            requiresAuth: true,
            title: '物流管家'
          },
          children: [
            {
              path: '/logisticsManage/account',
              name: 'Account',
              component: Account,
              meta: {
                title: '物流管家'
              },
            },
            {
              path: '/logisticsManage/order',
              name: 'Order',
              component: Order,
              meta: {
                title: '物流管家'
              },

            },
            {
              path: '/logisticsManage/orderTwo',
              name: 'OrderTwo',
              component: OrderTwo,
              meta: {
                title: '物流管家'
              },
            },
            {
              path: '/logisticsManage/bill',
              name: 'Bill',
              component: Bill,
              meta: {
                title: '物流管家'
              },
            }
          ]
        }
      ]
    }, {//注册登陆找回密码新的导航栏
      path: '/newMenuTabs',
      name: 'NewMenuTabs',
      component: NewMenuTabs,
      children: [
        {//注册
          path: '/register',
          name: 'Register',
          component: Register,
          meta: {
            title: '注册'
          }
        }, {//邀请注册
          path: '/invite',
          name: 'Invite',
          component: Invite,
          meta: {
            title: '邀请注册'
          }
        }, {//登录
          path: '/login',
          name: 'Login',
          component: Login,
          meta: {
            title: '登录'
          }
        }, {//忘记密码
          path: '/forgetPassword',
          name: 'ForgetPassword',
          component: ForgetPassword,
          meta: {
            title: '忘记密码'
          }
        }
      ]
    },  {//首页
      path: '/plan',
      name: 'plan',
      component: plan,
      meta: {
        title: '大屏数据'
      }
    },
    {
      path: '/planMap',
      name: 'planMap',
      component: planMap,
      meta: {
        title: '地图'
      }
    },
    {
      path: '/Monitoring',
      name: 'Monitoring',
      component: Monitoring,
      meta: {
        title: '设施监控'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js